"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Constraint2 = _interopRequireDefault(require("../Constraint"));

var _IsBlank = _interopRequireDefault(require("../Basic/IsBlank"));

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @class ./constraints/Basic/Date
 */
var Date =
/*#__PURE__*/
function (_Constraint) {
  _inherits(Date, _Constraint);

  /**
   * Assumes not leap year by default.
   *
   * @type {Number[]}
   */

  /**
   * Constructor.
   *
   * @param {String} errorMessage
   */
  function Date() {
    var _this;

    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, Date);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Date).call(this));
    Object.defineProperty(_assertThisInitialized(_this), "daysInMonth", {
      enumerable: true,
      writable: true,
      value: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    });
    Object.defineProperty(_assertThisInitialized(_this), "isLeapYear", {
      enumerable: true,
      writable: true,
      value: function value(year) {
        _newArrowCheck(this, this);

        var isLeap = false;

        if (!(year % 4) && year % 100 || !(year % 400)) {
          isLeap = true;
        }

        return isLeap;
      }.bind(this)
    });
    Object.defineProperty(_assertThisInitialized(_this), "isValid", {
      enumerable: true,
      writable: true,
      value: function value() {
        _newArrowCheck(this, this);

        var isValid = false;
        var isEmpty = new _IsBlank.default().setValue(_this.value).isValid();
        var minLength = new _index.MinLength(10).setValue(_this.value).isValid();
        var maxLength = new _index.MaxLength(11).setValue(_this.value).isValid();

        if (!isEmpty && minLength && maxLength) {
          var bits = _this.value.split(/\.|\/|-/);

          var y = bits[2],
              m = bits[1],
              d = bits[0];

          if (_this.isLeapYear(y)) {
            _this.daysInMonth[1] = 29;
          }

          if (!/\D/.test(String(d)) && d > 0 && d <= _this.daysInMonth[--m] && y.length === 4) {
            isValid = true;
          }
        }

        return isValid;
      }.bind(this)
    });
    _this.message = 'This is not valid date.';

    if (errorMessage !== '') {
      _this.message = errorMessage;
    }

    return _this;
  }
  /**
   * If evenly divisible by 4 and not evenly divisible by 100,
   * or is evenly divisible by 400, then a leap year
   *
   * @param {String} year
   *
   * @Returns {Boolean}
   */


  return Date;
}(_Constraint2.default);

var _default = Date;
exports.default = _default;